import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://emans-peppers.com';
const DEFAULT_OG_IMAGE = 'https://emans-peppers.com/favicon-512x512.png';

const Seo = ({
  title,
  description,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  jsonLd,
  noindex = false,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title || "Eman's Peppers | Peptide Research Products";
  const desc =
    description ||
    "Eman's Peppers is a US-based research peptide supplier — Retatrutide, Tirzepatide, BPC-157, GHK-Cu, MOTS-C and more for laboratory research only. Not a food brand or recipe site.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-snippet:-1, max-image-preview:large'} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Eman's Peppers" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
